import { AdmService } from 'src/app/shared/services/adm.service';
import { Component, Inject, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IdentityRole} from 'src/app/shared/models/identityRole';
import { Router } from '@angular/router';
import { Usuario } from 'src/app/shared/models/usuario';

import { UsuariosService } from 'src/app/shared/services/usuarios.service';

@Component({
  selector: 'app-confirmacion-dialog',
  templateUrl: './confirmacion-dialog.component.html'
})
export class ConfirmacionDialogComponent implements OnInit {

  Titulo:string;

  public Etiquetas: {
       
    Si: string,
    No: string
    
  }

  constructor(
    private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ConfirmacionDialogComponent>,
    private fb: FormBuilder,
    private router: Router,
    private usuarioService: UsuariosService,
    private usuariosService: UsuariosService,

    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    if (data != null){
      this.Titulo = data;
    }
  }

  ngOnInit() {
    this.Etiquetas = {
      Si: this.configService.etiquetas.Si,
      No: this.configService.etiquetas.No
    }
  }

  respuesta(respuesta:boolean){
    this.dialogRef.close(respuesta);
  }

}
